import BreadcrumbDropdown from "./BreadcrumbDropdown";
import BreadcrumbSheet from "./BreadcrumbSheet";

/**
 * A crumb that opens a menu instead of navigating: a sidebar group listing its
 * pages, or the ellipsis holding the levels a long trail hides. A dropdown on wide
 * screens, a bottom sheet on a phone (`asSheet`); both take the same items.
 */
export default function BreadcrumbMenu({ asSheet = false, title, ...props }) {
  return asSheet ? (
    <BreadcrumbSheet title={title} {...props} />
  ) : (
    <BreadcrumbDropdown {...props} />
  );
}
